import React from "react";

const SliderPrevIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="48"
      height="48"
      viewBox="0 0 48 48"
      fill="none"
    >
      <g opacity="0.4">
        <path
          d="M17.1797 33.16L26.3397 24L17.1797 14.82L19.9997 12L31.9997 24L19.9997 36L17.1797 33.16Z"
          fill="black"
        />
      </g>
    </svg>
  );
};

export default SliderPrevIcon;
